export default "__VITE_ASSET__DGDydar4__"